import { createBrowserRouter } from 'react-router';
import { Layout } from './components/Layout';
import { LoginPage } from './components/LoginPage';
import { NoAccessPage } from './components/NoAccessPage';
import { ContractsBoard } from './components/ContractsBoard';
import { RouteErrorBoundary } from './components/RouteErrorBoundary';

// PERF-3: route-level code-splitting. The board (ContractsBoard) is the
// landing route and stays in the critical path; the heavier secondary routes
// (Reports pulls in recharts; Admin is large; History/Settings/Time) are
// loaded on demand via React Router's native `lazy`. React Router shows the
// route's HydrateFallback/parent while the chunk loads, so no per-route
// Suspense boundary is required here.
export const router = createBrowserRouter([
  { path: '/login', Component: LoginPage, ErrorBoundary: RouteErrorBoundary },
  // 14-05: top-level (not nested under Layout) so Layout's basic_access
  // redirect doesn't loop this page back out.
  { path: '/no-access', Component: NoAccessPage, ErrorBoundary: RouteErrorBoundary },
  // Stock counting is available to active staff without granting access to the
  // contracts board, purchasing or the wider stock administration screens.
  {
    path: '/stock-checks',
    lazy: async () => ({
      Component: (await import('./components/materials/StockChecksPage')).StockChecksPage,
    }),
    ErrorBoundary: RouteErrorBoundary,
  },
  {
    path: '/',
    Component: Layout,
    ErrorBoundary: RouteErrorBoundary,
    children: [
      { index: true, Component: ContractsBoard },
      {
        path: 'reports',
        lazy: async () => ({ Component: (await import('./components/ReportsPage')).ReportsPage }),
      },
      {
        path: 'staff',
        lazy: async () => ({ Component: (await import('./components/StaffPage')).StaffPage }),
      },
      {
        path: 'history',
        lazy: async () => ({ Component: (await import('./components/HistoryPage')).HistoryPage }),
      },
      {
        path: 'time',
        lazy: async () => ({ Component: (await import('./components/TimePage')).TimePage }),
      },
      // Phase 70: native CB Materials pages (replaces the separate /materials app).
      {
        path: 'suppliers',
        lazy: async () => ({
          Component: (await import('./components/materials/SuppliersPage')).SuppliersPage,
        }),
      },
      {
        path: 'catalogue',
        lazy: async () => ({
          Component: (await import('./components/materials/CataloguePage')).CataloguePage,
        }),
      },
      {
        path: 'orders',
        lazy: async () => ({
          Component: (await import('./components/materials/OrdersPage')).OrdersPage,
        }),
      },
      {
        path: 'stock',
        lazy: async () => ({
          Component: (await import('./components/materials/StockPage')).StockPage,
        }),
      },
      {
        path: 'admin',
        lazy: async () => ({ Component: (await import('./components/AdminPage')).AdminPage }),
      },
      {
        path: 'settings',
        lazy: async () => ({ Component: (await import('./components/SettingsPage')).SettingsPage }),
      },
      {
        // GH #130: Superadmin-only role-permission matrix editor.
        path: 'access-control',
        lazy: async () => ({
          Component: (await import('./components/AccessControlPage')).AccessControlPage,
        }),
      },
    ],
  },
]);
